import * as actionTypes from './actionsTypes';

export function getNotificationsList(params) {
	return {
		type: actionTypes.NOTIFICATIONS_LIST_GET,
		payload: {
			params,
		},
	};
}
export function delNotification(params) {
	return {
		type: actionTypes.NOTIFICATIONS_DELETE,
		payload: {
			params,
		},
	};
}

export function addEditNotification(params, effect) {
	return {
		type: actionTypes.NOTIFICATIONS_ADD_EDIT,
		payload: {
			params,
			effect,
		},
	};
}

export function getNotificationDetails(params) {
	return {
		type: actionTypes.NOTIFICATIONS_DETAILS_GET,
		payload: {
			params,
		},
	};
}

export function clearNotificationDetails() {
	return {
		type: actionTypes.NOTIFICATIONS_DETAILS_CLEAR,
	};
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/actions/notifications.js